import React from 'react';
import { usePrices, formatUsdPrice } from '../../hooks/usePrices';
import { lcdClient } from '../../lcd';
import styles from './index.module.css';

/**
 * Scrolling price strip under the header.
 *
 * Two identical groups sit side by side, each at least as wide as the strip,
 * and the track slides exactly one group's width before repeating. That is
 * what makes the loop seamless: the moment the animation resets, the second
 * group is already where the first one started.
 */
export default function PriceTicker() {
    const prices = usePrices(lcdClient);

    const items = [
        { symbol: 'LUNC', price: prices.lunc },
        { symbol: 'USTC', price: prices.ustc },
        { symbol: 'DFC', price: prices.dfc },
    ];

    // Three prices do not fill a wide screen, and stretching them across it
    // reads as a sparse row rather than a running strip. Repeat the set so the
    // group overflows even an ultra-wide viewport and the spacing stays tight.
    const REPEATS = 8;

    const group = key => (
        <div className={styles.group} key={key} aria-hidden={key === 'clone' ? 'true' : undefined}>
            {Array.from({ length: REPEATS }).map((_, pass) =>
                items.map(item => (
                    <span className={styles.item} key={`${item.symbol}-${pass}`}>
                        <span className={styles.symbol}>{item.symbol}</span>
                        <span className={styles.price}>{formatUsdPrice(item.price) || '—'}</span>
                    </span>
                )),
            )}
        </div>
    );

    return (
        <div className={styles.ticker} aria-label="Live token prices">
            <div className={styles.track}>
                {group('a')}
                {group('clone')}
            </div>
        </div>
    );
}
